<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.files') }}</h5>
    </template>

    <o-form-group v-if="legacyFileLinkVisible" :label="$t('sandoz.file_link_1')">
      <b-form-input v-model="item.file_link_1" :readonly="readonly" type="url"/>
      <small class="form-text text-muted">{{ $t('sandoz.file_link_1_help') }}</small>
    </o-form-group>

    <h6 class="mt-3">{{ $t('sandoz.compliance_file') }}</h6>
    <o-form-group :label="$t('sandoz.compliance_check_file')">
      <a v-if="item.compilance_check_file" :href="item.compilance_check_file" target="_blank">
        {{ $t('sandoz.compliance_check_file_open') }}
      </a>
      <span v-else class="text-muted">{{ $t('sandoz.no_file_uploaded') }}</span>
    </o-form-group>
    <o-form-group :label="$t('sandoz.compliance_deviation')">
      <b-form-textarea v-model="item.compliance_deviation" rows="2" :disabled="readonly"/>
    </o-form-group>

    <h6 class="mt-3">{{ $t('sandoz.attachments') }}</h6>
    <p class="text-muted small">{{ $t('sandoz.attachments_phase4_note') }}</p>
    <!-- Existing flavour pages use a child <contract-file> component. We'll port it here once
         every section is wired; for now the file list is read-only via the contract PDFs section. -->
    <ul v-if="files.length" class="list-unstyled mb-0">
      <li v-for="file in files" :key="file.id">
        <a :href="file.url || file.path" target="_blank">{{ file.name || file.filename }}</a>
        <span class="text-muted small ml-2" v-if="file.created_at">({{ file.created_at }})</span>
      </li>
    </ul>
    <p v-else class="text-muted">{{ $t('sandoz.no_attachments') }}</p>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Compliance file display + free-form attachment listing. The full upload UI from the legacy
 * <contract-file> component will land during the Phase 8 cutover — this section keeps the data
 * surface visible and read-only so contracts open without errors in the new page.
 */
export default {
  name: 'SectionFiles',
  mixins: [sectionMixin],
  computed: {
    legacyFileLinkVisible() {
      // Pre-2024 contracts used a single free-text link.
      return Number(this.item.contract_year) > 0 && Number(this.item.contract_year) <= 2023
    },
    files() {
      const result = []
      if (Array.isArray(this.item.pdfs)) {
        result.push(...this.item.pdfs)
      }
      if (Array.isArray(this.item.attachments)) {
        result.push(...this.item.attachments)
      }
      return result
    }
  }
}
</script>
